import mixins from "../../mixins";

const generateUID = mixins.generateUID.methods.generateUID;

export default {
  isEditMode: true,
  pageProperties: {
    "pages": [
      {
        "pageName": "home",
        "pageId": 1,
        "sections": [
          {
            "sectionId": "a0us1n",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                fieldId: "vas2fp",
                fieldType: "multi-campaign"
              }
            ]
          }
        ]
      },
      { // ProtexCharcoalCarrefour2022 campaign
        "pageName": "ProtexCharcoalCarrefour2022",
        "pageId": 28972,
        "isPublic": true,
        "sections": [
          {
            "sectionId": "orbg8s",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                "fieldType": "refresh-token",
                "fieldId": "ij3433"
              },
              {
                fieldId: "dte-003",
                fieldType: "dataLayer-event",
                properties: {
                  eventName: "PageView",
                  fbEvent: "PageView"
                }
              },
              {
                "fieldType": "key-visual",
                "fieldId": "296eg1",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "styles": {
                    "margin": '2% 0 0 0',
                    "padding": '0'
                  },
                  "noContainer": false,
                  "addRow": true,
                  "desktopImageUrl": "/assets/campaigns/ProtexCharcoalCarrefour2022/key-visual.png",
                  "mobileImageUrl": "/assets/campaigns/ProtexCharcoalCarrefour2022/key-visual.png"
                }
              },
              {
                "fieldType": "participa",
                "fieldId": "acsh315",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "color": "#FF6905",
                  "buttonClass": "btn-cyan",
                  "nextPage": "ProtexCharcoalCarrefour2022/InscrieBonul",
                  "campaign": "ProtexCharcoalCarrefour2022",
                  "steps": [
                    {
                      "title": "Pasul 1",
                      "text": "Cumpara produse Protex in valoare de 18 lei",
                      "image": "select"
                    },
                    {
                      "title": "Pasul 2",
                      "text": "Incarca bonul fiscal",
                      "image": "receipt"
                    },
                    {
                      "title": "Pasul 3",
                      "text": "Inregistreaza-te",
                      "image": "register"
                    },
                    {
                      "title": "Pasul 4",
                      "text": "Castiga premii!",
                      "image": "reward"
                    }
                  ]
                }
              }
            ]
          }
        ]
      },
      { // Upload receipt
        "pageName": "ProtexCharcoalCarrefour2022/InscrieBonul",
        "pageId": 22345,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "step-counter",
                "fieldId": "tj4j49",
                "properties": {
                  "activeIndex": 0,
                  "colorSchema": "#FF6905",
                  "stepShadow": "rgba(255, 105, 5, 1)",
                  "startGradient": "linear-gradient(57.51deg, #FF6905 3.98%, #FF9752 95.58%)",
                  "endGradient": "linear-gradient(to right, rgba(255, 105, 5, 1) 0% 100%)",
                  "completedGradient": "linear-gradient(57.51deg, #FF6905 3.98%, #FF9752 95.58%), #ffffff",
                  "steps": [
                    {
                      "title": "Incarca bonul fiscal/factura",
                      "page": "ProtexCharcoalCarrefour2022/InscrieBonul"
                    },
                    {
                      "title": "Inregistreaza-te",
                      "page": "ProtexCharcoalCarrefour2022/Inregistreaza"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1>Incarca bonul fiscal/factura</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "La acest pas, te rugam sa incarci dovada achizitionarii produselor Protex Charcoal",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '24px;',
                    "color": "#2E2E2E"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Te rugam sa faci o poza a intregului/intregii bon fiscal/facturi sau sa incarci un pdf al facturii",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '16px;',
                    "line-height": "26px;",
                    "color": "#2E2E2E"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "receipt-processor",
                      "fieldId": "klvakj",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca bonul fiscal/factura.</span>.<br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#FF6905",
                        "fileUploadColor": "rgba(0, 0, 0, 0.5)",
                        "textColor": "#2E2E2E",
                        "borderColor": "#FFAD70",
                        "buttonClass": "btn-orange",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "successAction": {
                          "fn": "goToPage",
                          "params": "ProtexCharcoalCarrefour2022/Inregistreaza"
                        },
                        "campaignId": "charcoal-carrefour",
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "eraseColor": "#fff",
                        "eraseSize": 12,
                        "cropColor": "#FFAD70",
                        "cropBackground": "rgba(0,0,0,0.6)",
                        "cropTitle": "Decupeaza",
                        "eraseTitle": "Acopera",
                        "dragTitle": "Deplaseaza imaginea",
                        "zoomInTitle": "Mareste",
                        "zoomOutTitle": "Micsoreaza",
                        "selectImageTitle": "Select an Image",
                        "selectAnotherTitle": "Select Another",
                        "controlsBackground": "#FF6905",
                        "backgroundColorBtn": "black"
                      }
                    },
                    {
                      "fieldType": "empty-bucket",
                      "properties": {
                        "grid": {
                          "columns": 7
                        },
                        "fields": [
                          {
                            "fieldType": "receipt-information",
                            "fieldId": "5mq1p6",
                            "properties": {
                              "grid": {
                                "alignItems": "center",
                                "justifyContent": "center",
                                "columns": "12"
                              },
                              "styles": {
                                "text-align": "left",
                                "background": "#FF6905"
                              },
                              "color": "#FF6905",
                              "textColor": "#2E2E2E",
                              "descriptionText": "Te rugam sa faci o poza a bonului fiscal/facturii. Urmatoarele informatii trebuie sa fie vizibile:",
                              "receiptImage": "receipt11",
                              "steps": [
                                {
                                  "text": "Nume Retailer/ Magazin",
                                  "label": "A"
                                },
                                {
                                  "text": "Produsele care intra in promotie si pretul lor",
                                  "label": "B"
                                },
                                {
                                  "text": "Suma totala a bonului/facturii in LEI/RON",
                                  "label": "C"
                                },
                                {
                                  "text": "Nr bonului fiscal/facturii",
                                  "label": "D"
                                },
                                {
                                  "text": "Data si ora de pe bon sau de pe factura",
                                  "label": "E"
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "bsbsd35",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "receipt-image-information"
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "40px"
            },
            "container": true,
            "buttonsWrap": true,
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm1",
                "properties": {
                  "grid": {
                    "columns": "0"
                  },
                  "addClass": "btn-link",
                  "text": "Inapoi",
                  "disabled": false,
                  "styles": {
                    "position": "absolute;",
                    "left": 0
                  },
                  "action": {
                    "fn": "goToPage",
                    "params": "ProtexCharcoalCarrefour2022"
                  }
                }
              },
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Continua",
                  "addClass": "btn-cyan",
                  "shouldCheckCrop": true,
                  "requires": ["klvakj"],
                  "action": {
                    "fn": "sendReceipt",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // Register form
        "pageName": "ProtexCharcoalCarrefour2022/Inregistreaza",
        "pageId": 634553232,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12
            },
            "container": true,
            "fields": [
                {
                    "fieldType": "step-counter",
                    "fieldId": "tj4j49",
                    "properties": {
                      "activeIndex": 1,
                      "colorSchema": "#FF6905",
                      "stepShadow": "rgba(255, 105, 5, 1)",
                      "startGradient": "linear-gradient(57.51deg, #FF6905 3.98%, #FF9752 95.58%)",
                      "endGradient": "linear-gradient(to right, rgba(255, 105, 5, 1) 0% 100%)",
                      "completedGradient": "linear-gradient(57.51deg, #FF6905 3.98%, #FF9752 95.58%), #ffffff",
                      "steps": [
                        {
                          "title": "Incarca bonul fiscal/factura",
                          "page": "ProtexCharcoalCarrefour2022/InscrieBonul"
                        },
                        {
                          "title": "Inregistreaza-te",
                          "page": "ProtexCharcoalCarrefour2022/Inregistreaza"
                        }
                      ]
                    }
                  },
              {
                "fieldType": "paragraph",
                "fieldId": "fckzg7",
                "properties": {
                  "text": "<h1>Formular de inscriere</h1>"
                }
              }
            ]
          },
          {
            "sectionId": "ci88zt",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 4,
              "marginTop": "40px"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "form-component",
                "fieldId": "j765n4b",
                "properties": {
                  "styles": {
                    "margin": "0",
                    "justifyContent": "center",
                    "--maxWidth": "545px",
                    "--backgroundColor": "#FAFAFA"
                  },
                  "grid": {
                    "alignItems": "center",
                    "columns": "0",
                    "justifyContent": "center"
                  },
                  "requires": [
                    "1"
                  ],
                  "successAction": {
                    "fn": "goToPage",
                    "params": "ProtexCharcoalCarrefour2022/Multumim"
                  },
                  "endpoint": "/register",
                  "fields": [
                    {
                      "fieldId": "b4baqs",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "surname",
                        "autocomplete": "no",
                        "label": "Prenume",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#FFC499",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "gofije",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "name",
                        "autocomplete": "no",
                        "label": "Nume",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#FFC499",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf9",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "email",
                        "label": "E-mail",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|email",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#FFC499",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "vake42c",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "mobile",
                        "label": "Numar de telefon",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|phoneNumber",
                        "grid": {
                          "columns": 12
                        },
                        "autocomplete": "nope",
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#FFC499",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "ko3h1sz",
                      "fieldType": "paragraph",
                      "properties": {
                        "text": "<b>Atentie!</b> In cazul introducerii unei adrese de e-mail gresite, daca esti declarat castigator, nu vei primi premiul castigat, conform Articolelor 4.3, 4.4, 8.7 si 8.8 din Regulamentul campaniei.",
                        "grid": {
                          "columns": "12",
                          "marginTop": "35px"
                        },
                        "classes": ['disclaimer'],
                        "styles":{
                          "color": "#2E2E2E !important"
                        }
                      }
                    },
                    {
                      "fieldId": "wgc3j7",
                      "fieldType": "checkbox",
                      "properties": {
                        "name": "terms",
                        "validation": {
                          "required": {
                            "allowFalse": false
                          }
                        },
                        "validationName": "Termenii si conditiile sunt necesare",
                        "grid": {
                          "columns": "12",
                          "paddingTop": "10px"
                        },
                        "styles": {
                          "margin-top": "30px",
                          "--color": "rgba(5, 14, 35, 1)",
                          "--border": "1px solid #FFC499",
                          "background-color":"border: #FFC499",
                          "--checkedCheckbox": "url(/assets/icons/form/checked_checkbox.svg)",
                          "--uncheckedCheckbox": "url(/assets/icons/form/unchecked_checkbox.svg)"
                        },
                        "label": `Confirm ca am peste 18 ani. Confirm <a href="/files/ProtexCharcoalCarrefour2022Regulament.pdf" target="_blank"><u>termenii si conditiile</u></a> si <a href="https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy" target="_blank"><u>politica de confidentialitate</u></a></div>.`
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "yh453gg4",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "120px"
            },
            "container": true,
            "buttonsWrap": true,
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm1",
                "properties": {
                  "grid": {
                    "columns": "0"
                  },
                  "addClass": "btn-link",
                  "text": "Inapoi",
                  "disabled": false,
                  "styles": {
                    "position": "absolute;",
                    "left": 0
                  },
                  "action": {
                    "fn": "goToPage",
                    "params": "ProtexCharcoalCarrefour2022/InscrieBonul"
                  }
                }
              },
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "TRIMITE",
                  "disabled": false,
                  "addClass": "btn-cyan",
                  "action": {
                    "fn": "sendForm",
                    "params": "j765n4b"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Winner form page
        "pageName": "ProtexCharcoalCarrefour2022/WinnerPage",
        "isPublic": true,
        "pageId": 634553,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "basb782",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "vasv24",
                properties: {
                  variables: [
                    {
                      query: "customerToken",
                      state: "customerToken"
                    }
                  ]
                }
              },
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "receiptToken",
                      state: "receiptToken"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1>Formular pentru Castigator</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Completeaza-ti adresa in formularul de mai jos pentru a-ti putea trimite premiul",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#2E2E2E"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "ci88zt",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 4,
              "marginTop": "50px"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "form-component",
                "fieldId": "j765n4b",
                "properties": {
                  "styles": {
                    "margin": "0",
                    "justifyContent": "center",
                    "--backgroundColor": "#fbfcfe"
                  },
                  "grid": {
                    "alignItems": "center",
                    "columns": "0",
                    "justifyContent": "center"
                  },
                  "requires": [
                    "1"
                  ],
                  "successAction": {
                    "fn": "goToPage",
                    "params": "ProtexCharcoalCarrefour2022/WinnerThankYou"
                  },
                  "endpoint": "/winnerRegister",
                  "fields": [
                    {
                      "fieldId": "b4baqs",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "surname",
                        "autocomplete": "no",
                        "label": "Prenume",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#FFC499",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "gofije",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "name",
                        "autocomplete": "no",
                        "label": "Nume",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#FFC499",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf9",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "email",
                        "label": "E-mail",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|email",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#FFC499",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "vake42c",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "mobile",
                        "label": "Numar de telefon",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|phoneNumber",
                        "grid": {
                          "columns": 12
                        },
                        "autocomplete": "nope",
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#FFC499",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf8",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "address",
                        "label": "Adresa",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "requiredAdress|adress",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#FFC499",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "ko3h1sz",
                      "fieldType": "paragraph",
                      "properties": {
                        "text": "*strada, numar, bloc, scara, apartament",
                        "grid": {
                          "columns": "12",
                          "marginTop": "20px;",
                          "marginBottom": "20px"
                        },
                        "classes": ['disclaimer'],
                        "styles":{
                          "color": "rgba(0, 41, 28, 1) !important"
                        }
                      }
                    }
                  ],
                  "extraFields": [
                    {
                      "fieldId": "bdsb632",
                      "fieldType": "select-input-county",
                      "properties": {
                        "name": "judet",
                        "label": "Judet",
                        "placeholder": "Judet",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "requiredJudet",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#FFC499",
                          "border-radius": "8px !important"
                        },
                        "autocomplete": "nope"
                      }
                    },
                    {
                      "fieldId": "bask257",
                      "fieldType": "select-input-city",
                      "properties": {
                        "name": "localitate",
                        "label": "Localitate",
                        "placeholder": "Localitate",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "requiredLocal",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#FFC499",
                          "border-radius": "8px !important"
                        },
                        "autocomplete": "nope"
                      }
                    },
                    {
                      "fieldId": "acasg235",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "postal",
                        "label": "Cod postal",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "integer|length:6",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#FFC499",
                          "border-radius": "8px"
                        },
                        "autocomplete": "nope",
                        "disablePaste": true
                      }
                    },
                    {
                      "fieldId": "bsdy4362",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "cnp",
                        "autocomplete": "no",
                        "label": "CNP",
                        "placeholder": "",
                        "text": "",
                        "validation": "required|integer|length:13",
                        "color": "#2E2E2E",
                        "grid": {
                          "alignItems": "center;",
                          "justifyContent": "center;",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#FFC499",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "bsadbsd325",
                      "fieldType": "checkbox",
                      "properties": {
                        "name": "cnpConfirm",
                        "validation": {
                          "required": {
                            "allowFalse": false
                          }
                        },
                        "validationName": "terms",
                        "grid": {
                          "columns": "12",
                          "paddingTop": "10px"
                        },
                        "styles": {
                          "margin-top": "30px",
                          "--color": "#2E2E2E",
                          "--checkedCheckbox": "url(/assets/icons/form/checked_checkbox.svg)",
                          "--uncheckedCheckbox": "url(/assets/icons/form/unchecked_checkbox.svg)"
                        },
                        "label": `Declar ca acest CNP imi apartine, cunoscand faptul ca orice declaratie falsa este sanctionata conform legii penale romane.`
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "yh453gg4",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "130px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "TRIMITE",
                  "disabled": false,
                  "addClass": "btn-cyan",
                  "action": {
                    "fn": "sendForm",
                    "params": "j765n4b"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Winner thank you
        "pageName": "ProtexCharcoalCarrefour2022/WinnerThankYou",
        "pageId": 99830,
        "noContainer": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "thank-you-winner",
                "fieldId": "gjd10",
                "properties": {
                  "campaign": "ProtexCharcoalCarrefour2022",
                  "campaignName": "CAMPANIE PROTEX CHARCOAL CARREFOUR HYPER & ONLINE",
                  "haveActivator": false,
                  "textColor": "#141414",
                  "imageStyles":{
                    'margin-bottom': '27%'
                  }
                }
              }
            ]
          }
        ]
      },
      { // Receipt reupload
        "pageName": "ProtexCharcoalCarrefour2022/receipt-reupload",
        "isPublic": true,
        "pageId": 32,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1>Te rugam sa incarci din nou bonul fiscal/factura</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "La acest pas, te rugam sa incarci dovada achizitionarii produselor Protex Charcoal",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '24px;',
                    "color": "#2E2E2E"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Te rugam sa faci o poza a intregului/intregii bon fiscal/facturi sau sa incarci un PDF al facturii",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '16px;',
                    "line-height": "30px;",
                    "color": "#2E2E2E"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "receipt-processor",
                      "fieldId": "klvakj",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca bonul fiscal/factura.</span>.<br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#FF6905",
                        "fileUploadColor": "rgba(0, 0, 0, 0.5)",
                        "textColor": "#2E2E2E",
                        "borderColor": "#FFAD70",
                        "buttonClass": "btn-orange",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "successAction": {
                          "fn": "goToPage",
                          "params": "ProtexCharcoalCarrefour2022/Multumim"
                        },
                        "campaignId": "charcoal-carrefour",
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "eraseColor": "#ffffff",
                        "eraseSize": 12,
                        "cropColor": "#FF6905",
                        "cropBackground": "rgba(0,0,0,0.6)",
                        "cropTitle": "Decupeaza",
                        "eraseTitle": "Acopera",
                        "dragTitle": "Deplaseaza imaginea",
                        "zoomInTitle": "Mareste",
                        "zoomOutTitle": "Micsoreaza",
                        "selectImageTitle": "Select an Image",
                        "selectAnotherTitle": "Select Another",
                        "controlsBackground": "#FF6905",
                        "backgroundColorBtn": "black",
                        "reUpload": true,
                        "tokenName": "token"
                      }
                    },
                    {
                      "fieldType": "empty-bucket",
                      "properties": {
                        "grid": {
                          "columns": 7
                        },
                        "fields": [
                          {
                            "fieldType": "receipt-information",
                            "fieldId": "5mq1p6",
                            "properties": {
                              "grid": {
                                "alignItems": "center",
                                "justifyContent": "center",
                                "columns": "12"
                              },
                              "styles": {
                                "text-align": "left"
                              },
                              "color": "#FF6905",
                              "textColor": "#2E2E2E",
                              "descriptionText": "Te rugam sa faci o poza a bonului fiscal/facturii. Urmatoarele informatii trebuie sa fie vizibile:",
                              "receiptImage": "receipt11",
                              "steps": [
                                {
                                  "text": "Nume magazin",
                                  "label": "A"
                                },
                                {
                                  "text": "Produsele participante la promotie si pretul lor",
                                  "label": "B"
                                },
                                {
                                  "text": "Suma totala a bonului fiscal/facturii in LEI",
                                  "label": "C"
                                },
                                {
                                  "text": "Nr. bonului fiscal/facturii",
                                  "label": "D"
                                },
                                {
                                  "text": "Data si ora de pe bonul fiscal sau factura",
                                  "label": "E"
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "bsbsd35",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "receipt-image-information"
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "40px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Trimite",
                  "addClass": "btn-cyan",
                  "shouldCheckCrop": true,
                  "requires": ["klvakj"],
                  "action": {
                    "fn": "sendReceipt",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // Product reupload
        "pageName": "ProtexCharcoalCarrefour2022/product-reupload",
        "isPublic": true,
        "pageId": 1282452,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1>Incarca o poza a produsului</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basv352",
                "properties": {
                  "text": "Incarca o poza cu produsele participante in campanie",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#2E2E2E"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Doar fisiere JPG, si PNG sunt acceptate. Fisierul poate avea maxim 16MB.",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '14px;',
                    "line-height": "20px;",
                    "color": "#2E2E2E"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "product-upload",
                      "fieldId": "ase123v",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca poza</span><br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Fisierul poate avea maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#FF6905",
                        "borderColor": "#FFAD70",
                        "buttonClass": "btn-orange",
                        "textColor": "#2E2E2E",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "endpoint": "/uploadProductPhoto",
                        "successAction": {
                          "fn": "goToPage",
                          "params": "ProtexCharcoalCarrefour2022/Multumim"
                        },
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "reUpload": true
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "marginTop": "60px",
              "marginBottom": "30px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Trimite",
                  "addClass": "btn-cyan",
                  "shouldCheckCrop": false,
                  "requires": ["ase123v"],
                  "action": {
                    "fn": "sendProductPhotos",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // Thank you
        "pageName": "ProtexCharcoalCarrefour2022/Multumim",
        "pageId": 99800,
        "noContainer": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "thank-you",
                "fieldId": "gjd10",
                "properties": {
                  "campaign": "ProtexCharcoalCarrefour2022",
                  "campaignName": "CAMPANIE PROTEX CHARCOAL CARREFOUR HYPER & ONLINE",
                  "haveActivator": false,
                  "borderColor": "#FFAD70",
                  "textColor": "#2E2E2E",
                  "referenceColor": "#FF903D",
                  "imageStyles":{
                    'margin-bottom': '27%'
                  }
                }
              }
            ]
          }
        ]
      },
      { // Error page
        "pageName": "error-page",
        "pageId": 10424,
        isPublic: true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12
            },
            "container": true,
            fields: [
              {
                "fieldType": "error-page",
                "fieldId": "gjd10",
                "properties": {
                  "grid": {
                    "columns": "12"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Faq
        "pageName": "ProtexCharcoalCarrefour2022/IntrebariFrecvente",
        "isPublic": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "text-list",
                "fieldId": "a6prst",
                "properties": {
                  "colorSchema": "#2E2E2E",
                  "title": "Intrebari frecvente",
                  "items": [
                    { // 1
                      title: `Ce conditii trebuie sa indeplinesc pentru a participa la „CAMPANIA PROTEX CHARCOAL CARREFOUR HYPER & ONLINE”?`,
                      text: `
                      <ul>
                          <li>Varsta minima: Trebuie sa ai cel putin 18 ani.</li>
                          <li>Domiciliul: Trebuie sa ai domiciliul in Romania.</li>
                          <li>Numarul de telefon: Trebuie sa ai un numar de telefon mobil romanesc.</li>
                          <li>Adresa de e-mail: Poti participa doar cu propria adresa de e-mail.</li>
                      </ul>
                      <div style="margin-top: 10px">Nota: Numarul de telefon si adresa de e-mail pot fi combinate o singura data pentru intreaga
                      perioada a campaniei.</div>`
                    },
                    { // 2
                      title: `Cum pot participa la „CAMPANIA PROTEX CHARCOAL CARREFOUR HYPER & ONLINE”?`,
                      text: `Poti participa doar online, prin intermediul site-ului campaniei <a href="/ProtexCharcoalCarrefour2022" target="_blank">promocolgatepalmolive.ro</a>. Din pacate, nu este posibila participarea prin posta. Procesul poate fi descris dupa cum urmeaza:
                      <ul style="margin-top: 10px; margin-bottom: 10px">
                          <li>Achizitioneaza produse participante in valoare de cel putin 18 lei;</li>
                          <li>Fotografiaza si incarca bonul fiscal/factura;</li>
                      </ul>
                      Doar in cazul solicitarii ulterioare, trebuie sa incarci o fotografie a partii posterioare a produsului tau, respectiv produselor tale Protex. (Trebuie sa te asiguri ca este vizibil codul de bare al produsului tau, respectiv produselor tale.) In mod suplimentar, bonul fiscal/factura trebuie sa apara clar/a si lizibil/a pe fotografia cu produsul.
                      <ul style="margin-top: 10px;">
                          <li>Introdu adresa de e-mail, numarul de telefon si alte informatii personale;</li>
                          <li>Accepta regulamentul de participare si protectia datelor.</li>
                      </ul>
                      <div style="margin-top: 10px">Nota: Nu este posibila utilizarea unor adrese de e-mail diferite si numere de telefon mobil (conturi de utilizator) pentru aceeasi persoana.</div>`
                    },
                    { // 3
                      title: `Pe cine trebuie sa contactez daca am o intrebare privitoare la „CAMPANIA PROTEX CHARCOAL CARREFOUR HYPER & ONLINE”?`,
                      text: `Te rugam sa contactezi serviciul de relatii clienti Protex la adresa <a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro</a>`
                    },
                    { // 4
                      title: `Ce produse trebuie sa cumpar pentru a participa la „CAMPANIA PROTEX CHARCOAL CARREFOUR HYPER & ONLINE”?`,
                      text: `Produsele participante sunt urmatoarele: toata gama de produse Protex`
                    },
                    { // 5
                      title: `De unde pot cumpara produsele participante la „CAMPANIA PROTEX CHARCOAL CARREFOUR HYPER & ONLINE”?`,
                      text: `Poti cumpara toate produsele participante la campanie din Carrefour Hyper si online in Romania.`
                    },
                    { // 6
                      title: `Cand pot participa la „CAMPANIA PROTEX CHARCOAL CARREFOUR HYPER & ONLINE”?`,
                      text: `Perioada de achizitie a produselor participante este cuprinsa intre 28.04.2022 si, inclusiv, 28.05.2022. Termenul-limita pentru trimiterea formularului de inregistrare online si incarcarea bonului fiscal/facturii de achizitie este 28.05.2022.`
                    },
                    { // 7
                      title: `Cat de des pot participa la „CAMPANIA PROTEX CHARCOAL CARREFOUR HYPER & ONLINE”?`,
                      text: `Nu exista limita de participare. Poti participa de cate ori doresti.`
                    },
                    { // 8
                      title: 'Cand pot primi premiul?',
                      text: `Dupa tragerea la sorti – in cazul in care esti declarat/a castigator/e –, vei fi imediat contactat/a
                      pentru a furniza adresa de livrare si CNP-ul. Vei primi premiul prin curier in termen de o luna dupa
                      trimiterea informatiilor suplimentare.`
                    },
                    { // 9
                      title: `Cât timp trebuie să păstrez bonul fiscal/factura?`,
                      text: `Trebuie să păstrezi bonul fiscal/factura până în momentul în care primești premiul.`
                    },
                    { // 10
                        title: 'Bonul meu fiscal/factura contine mai multe produse participante decat minimul necesar. Pot doua sau mai multe persoane sa foloseasca bonul fiscal/factura pentru participarea la tragerea la sorti?',
                        text: `In principiu, un bon fiscal/o factura poate participa o singura data la „CAMPANIA PROTEX
                        CHARCOAL CARREFOUR HYPER & ONLINE”. Produsele participante enumerate pe bonul
                        fiscal/factura nu pot fi luate in considerare, iar un produs participant nu poate fi transferat altei
                        persoane.`
                    },
                    { // 11
                      title: 'Nu am primit un e-mail de confirmare dupa terminarea procesului de inscriere. Ce trebuie sa fac?',
                      text: `Dupa ce te-ai inregistrat, vei primi un e-mail de confirmare cu un numar de referinta format din 10
                      caractere alfanumerice. Te rugam sa verifici dosarul de SPAM si JUNK. Daca nu ai primit un numar
                      de referinta format din 10 caractere alfanumerice, te rugam sa participi din nou prin intermediul
                      site-ului pentru promotii <a href="/ProtexCharcoalCarrefour2022" target="_blank">promocolgatepalmolive.ro./ProtexCharcoalCarrefour2022</a>.`
                    },
                    { // 12
                      title: 'Am introdus o adresa de e-mail gresita. Exista o modalitate de a afla daca am castigat?',
                      text: `Fiecare castigator din campanie va fi anuntat pe pagina cu castigatori: <br />
                      <a href="/ProtexCharcoalCarrefour2022/castigatori" target="_blank">promocolgatepalmolive.ro/ProtexCharcoalCarrefour2022/castigatori/</a>`
                    },
                    { // 13
                      title: 'Cand parcurg procesul de inscriere pentru participarea la tragerea la sorti, acesta se blocheaza la un moment dat. Ce trebuie sa fac?',
                      text: `Daca te incurci in timpul procesului de inscriere din motive tehnice, iti recomandam – daca este
                      posibil – sa utilizezi un alt dispozitiv. De exemplu, treci de pe telefonul mobil pe calculator. Daca
                      acest lucru nu rezolva problema, poti incerca sa folosesti un alt browser (Google Chrome, Microsoft
                      Edge, Mozilla Firefox). Daca sfaturile nu te ajuta, te rugam sa trimiti un e-mail departamentului
                      nostru de suport: <a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro</a>. Te rugam sa furnizezi o descriere precisa a
                      problemei in e-mailul tau – o captura de ecran cu pasul la care te blochezi este perfecta. Alte
                      informatii utile sunt dispozitivul tau, sistemul de operare si browserul pe care le folosesti. Echipa
                      noastra de suport se va stradui sa te ajute.`
                    },
                    { // 14
                      title: 'Cum imi pot da seama daca am reusit sa incarc bonul fiscal/factura?',
                      text: `Dupa ce incarci bonul fiscal/factura si introduci informatiile personale, inclusiv numarul tau de
                      telefon mobil, va aparea un mesaj pe ecran care confirma inscrierea participarii tale si iti afiseaza
                      numarul personal de referinta. Vei primi cu promptitudine si un e-mail de confirmare sau respingere
                      a participarii pe adresa furnizata.`
                    },
                    { // 15
                      title: 'Cat timp este disponibil departamentul de suport?',
                      text: `Echipa noastra de suport este disponibila de la inceputul campaniei timp de 6 saptamani dupa
                      expirarea datei de inregistrare. Dupa 09.07.2022, datele tale vor fi sterse, departamentul de suport
                      va fi inchis, iar intrebarile tale nu vor mai fi tratate.`
                    },
                    { // 16
                      title: 'Bonul fiscal/factura mi-a fost respins/a deoarece nu sunt lizibile toate informatiile. Ce informatii trebuie sa fie lizibile?',
                      text: `Magazinul, produsele participante Protex, pretul de achizitie al produselor participante, valoarea
                      totala a bonului fiscal/facturii, numarul bonului fiscal/facturii, TVA-ul, orice reduceri care pot fi
                      aplicate, precum si ora si data.`
                    },
                    { // 17
                        title: 'De ce mi se solicita sa incarc o fotografie cu produsele?',
                        text: `Poate fi din cauza faptului ca bonul fiscal/factura nu contine denumirea completa a produselor
                        achiziționate.
                        In partea de jos a e-mailului de respingere, vei gasi un buton pentru a incarca fotografia cu
                        codurile de bare ale produselor. Da clic pe buton si vei fi redirectionat/a automat catre incarcarea
                        din nou a fotografiei cu produsele. Te rugam sa realizezi o fotografie noua a produselor si s-o incarci
                        din nou in termen de 72 de ore. Retine ca butonul nu mai este functional dupa 72 de ore.
                        Daca participarea ta este respinsa din nou, te rugam sa ne contactezi prin intermediul adresei de
                        e-mail de suport, care poate fi gasita si in e-mailul de respingere (<a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro</a>).`
                    },
                    { // 18
                      title: 'De ce mi-a fost respinsa participarea, desi am cumparat produsele participante?',
                      text: `De exemplu, poate fi din cauza unei erori tehnice sau a faptului ca bonul fiscal/factura nu este
                      suficient de lizibil/a sau este supraexpus/a.
                      In partea de jos a e-mailului de respingere, vei gasi un buton pentru a incarca bonul fiscal/factura
                      din nou. Da clic pe buton si vei fi redirectionat/a automat catre incarcarea din nou a bonului
                      fiscal/facturii. Te rugam sa realizezi o fotografie noua a bonului fiscal/facturii si s-o incarci din nou in
                      termen de 72 de ore. Butonul nu mai este functional dupa 72 de ore.
                      Daca participarea ta este respinsa din nou, te rugam sa ne contactezi prin intermediul adresei de
                      e-mail de suport, care poate fi gasita si in e-mailul de respingere (<a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro</a>).`
                    },
                    { // 19
                      title: 'Bonul meu fiscal/factura nu a fost acceptat/a sau chiar a fost marcat/a ca fals/a. Cum este posibil asa ceva?',
                      text: `In cazul in care bonul fiscal/factura este prea neclar/a sau prea intunecat/a sau supraexpus/a
                      astfel incat informatiile nu mai pot fi lizibile, exista posibilitatea sa primesti un e-mail de respingere, in
                      care bonul fiscal/factura este descris/a drept un fals sau esti rugat/a sa furnizezi o fotografie mai
                      buna cu <b>Incarca bonul tau fiscal/factura</b>. Ajuta-ne sa iti acceptam participarea rapid si fara
                      complicatii, incarcand o fotografie de buna calitate (nu o scanare!) a bonului tau fiscal/facturii,
                      care demonstreaza ca ai un bon fiscal/o factura original/a si in care sunt lizibile toate informatiile
                      necesare. Economiseste mult timp si neplaceri atat pentru tine, cat si pentru noi.`
                    },
                    { // 20
                      title: 'Pot trimite bonul fiscal/factura si prin e-mail?',
                      text: `Ne pare rau sa te informam ca nu este posibil sa sari peste procesul de inscriere la campanie si sa
                      ne trimiti bonul fiscal/factura prin e-mail. Echipa noastra de suport te poate ajuta doar in cazul in
                      care poti furniza numarul tau de referinta, care poate fi gasit in e-mailul de confirmare sau
                      respingere. In cazul in care nu ai primit un asemenea e-mail, trebuie sa repeti din nou procesul de
                      inregistrare.`
                    },
                    { // 21
                      title: 'Ce se intampla cu informatiile pe care le-am introdus pe site-ul promotiei?',
                      text: `Datele tale personale sunt prelucrate in scopul organizarii si desfasurarii Campaniei, pentru a-ti
                      putea permite participarea la aceasta si, in cazul in care ai fost declarat/a castigator/e, pentru a-ti
                      acorda premiul. Prelucrarea este necesara pentru executarea contractului la care esti parte, si
                      anume regulamentul Campaniei, cu care esti de acord in momentul inscrierii.`
                    },
                    { // 22
                      title: 'Am o intrebare generala despre Protex. Pe cine pot contacta?',
                      text: `Daca ai nevoie de informatii suplimentare privitoare la produsele noastre sau daca ai orice alte
                      intrebari, ne poti contacta prin intermediul linkului de mai jos: <b><a href="https://www.colgatepalmolive.ro/contact-us" target="_blank">https://www.colgatepalmolive.ro/contact-us</a>.</b>`
                    }
                  ],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "8"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Castigatori
        "pageName": "ProtexCharcoalCarrefour2022/castigatori",
        "isPublic": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "text-list",
                "fieldId": "a6prst",
                "properties": {
                  "colorSchema": "#000000",
                  "title": "Castigatori",
                  "ordered": false,
                  "items": [
                    {
                      title: `Camera video sport GoPro`,
                      text: `
                      <ul>
                          <li>Teleanu Elisabeta</li>
                      </ul>`
                    },
                    {
                      title: `Card cadou Carrefour`,
                      text: `
                      <ul>
                          <li>Bako Tunde</li>
                          <li>Bobe Gabriela</li>
                          <li>Braga Victor</li>
                          <li>Busu Adrian</li>
                          <li>Ceaus Octavian</li>
                          <li>Clinci Monica</li>
                          <li>Constantin Catalin</li>
                          <li>Flavia Imreh</li>
                          <li>Fratila Marin</li>
                          <li>Gheorghe Valeriu</li>
                          <li>Iordan Ionut</li>
                          <li>Mircescu Petre</li>
                          <li>Neculcea Florin</li>
                          <li>Otti Oana</li>
                          <li>Pircalabelu Vasile-Adrian</li>
                          <li>Sava Vlad</li>
                          <li>Stancu Gheorghita</li>
                          <li>Stanescu Alexandru</li>
                          <li>Stoenciu Daniel</li>
                          <li>Talas Andrei Florin</li>
                          <li>Teleanu Lucian</li>
                      </ul>`
                    }
                  ],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "8"
                  }
                }
              }
            ]
          }
        ]
      }
    ],
    "header": {
      "fieldType": "navbar",
      "fieldId": "cbx34t",
      "properties": {
        "dataLayer": {
          "GTM": {
            "Sitelocale": "ro-ro",
            "SiteTouchpoint": "",
            "SiteCountry": "RO",
            "SiteBrand": "",
            "SiteLanguage": "RO",
            "SitePlatform": "",
            "SiteEnvironment": "Prod",
            "SiteHost": "CTL",
            "SiteTechnicalAgency": "Justsnap",
            "SiteStatus": "Live",
            "GoogleAnalyticsLocal": "UA-15274544-47",
            "GoogleAnalyticsBrand": "",
            "GoogleAnalyticsSiteSpeedSampleRate": "high",
            "GoogleAnalyticsAllowLinker": "true",
            "GoogleAnalyticsLinkerDomains": "",
            "GoogleAnalyticsEnableOptimizely": "false",
            "GoogleAnalyticsConsentRequired": "true",
            "GoogleAnalyticsOptimizeContainerID": "",
            "GoogleAnalyticsReportingView": "",
            "GoogleReCaptcha": "true",
            "SiteLocalContainer": "",
            "FacebookRemarketingID": "270266680523196",
            "ConsentOverlay": "OneTrust",
            "ConsentOverlayID": "htmllang/7bfbeeed-fe9a-477f-99c7-84ca45614eb3-test",
            "SitePrivacyProtection": "GDPR"
          },
          "GTM_CODE": "GTM-TG4C5LV"
        },
        // "neustar": {
        //   "url": "https://aa.agkn.com/adscores/g.js?sid=9212300878"
        // },
        // "facebookPixel": {
        //   init: "270266680523196"
        // },
        "title": "",
        "color": "#FAF6EE",
        "grid": {
          "columns": 12
        },
        "logo": {
          "imageSource": "/assets/logo.svg",
          "width": 345,
          "alternateText": "Brand Logo",
          "paddingTop": "30px"
        },
        "fields": [
          {
            "fieldId": "ikz8vc",
            "fieldType": "anchor",
            "properties": {
              "text": "Regulament",
              "url": "/files/ProtexCharcoalCarrefour2022Regulament.pdf",
              "target": "_blank",
              "cssClass": "nav-link",
              "styles": {
                "color": "#050E23",
                "fontSize": "18px",
                "fontWeight": "400"
              }
            }
          },
          {
            "fieldId": "slnmdk",
            "fieldType": "anchor",
            "properties": {
              "text": "Intrebari frecvente",
              "url": "/ProtexCharcoalCarrefour2022/IntrebariFrecvente",
              "target": "_blank",
              "cssClass": "nav-link",
              "styles": {
                "color": "#050E23",
                "fontSize": "18px",
                "fontWeight": "400"
              }
            }
          }
        ],
        "showLine": false,
        "meta": [
          { "name": "title", "content": "Protex" },
          {
            "name": "description",
            "content": `Protex`
          },
          {
            "name": "keywords",
            "content": `Protex`
          }
        ]
      }
    },
    "footer": {
      "fieldType": "footer-component",
      "fieldId": "4tfbzz",
      "properties": {
        "links": [
          { "name": "", "link": "" }
        ],
        "supportLinks": [
          { "name": "Confidentialitate", "link": "https://www.jnjconsumer.ro/politica-confidentialitate" }
        ],
        "styles": {
          "color": "#000"
        },
        "fields": [
          {
            "fieldId": "ikz8vc1",
            "fieldType": "anchor",
            "properties": {
              "text": "Termeni si conditii",
              "url": "/files/ProtexCharcoalCarrefour2022Regulament.pdf",
              "target": "_blank",
              "styles": {
                "color": "#40454A"
              }
            }
          },
          {
            "fieldId": "slnmdk2",
            "fieldType": "anchor",
            "properties": {
              "text": " Politica de confidentialitate",
              "url": "https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy",
              "target": "_blank",
              "styles": {
                "color": "#40454A"
              }
            }
          }
        ]
      }
    },
    "campaignId": "charcoal-carrefour",
    "url": "https://promocolgatepalmolive.ro/",
    "name": "ProtexCharcoalCarrefour2022"
  },
  pageBuilder: {
    selectedField: {
      sectionId: '',
      fieldId: generateUID()
    }
  },
  componentStatus: {},
  modal: {
    type: 'error',
    message: 'An error has occurred',
    isActive: false
  },
  customerToken: '',
  receiptToken: '',
  receiptImage: '',
  campaignId: 'charcoal-carrefour',
  formData: new FormData(),
  campaignStartDate: "2022-04-28",
  campaignEndDate: "2022-05-28",
  showNavLinks: false,
  excludedPages: ['home'],
  cities: []
}
